// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RouteChangeProgress_wrapper__N786D","changing":"RouteChangeProgress_changing__4mkZV"};